import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import MultipleQuestions from './MultipleQuestions';
import OpinionScaleNumber from './OpinionScaleNumber';
import OpinionScaleStar from './OpinionScaleStar';
import OpinionScaleThumbs from './OpinionScaleThumbs';
import SliderQuestion from './SliderQuestion';
import SliderSmiliesQuestion from './SliderSmiliesQuestion';
import TextQuestion from './TextQuestion';
import TopHeading from './TopHeading';
import YesNoQuestion from './YesNoQuestion';



const percentage = 10;


export default function Index(preview) {
    return (
        <div className='d-flex flex-wrap flex-column question-preview-pg preview-header-fixed'>
            <div className="preview-header">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="radio-btn-screen d-inline-flex align-items-center justify-content-center">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Desktop" defaultValue="Desktop" defaultChecked />
                                <label className="form-check-label" htmlFor="Desktop" title="Desktop">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 17H21C22.1046 17 23 16.1046 23 15V5C23 3.89543 22.1046 3 21 3H3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H12ZM12 17V21M12 21H16M12 21H8" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>


                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Tablet" defaultValue="Tablet" />
                                <label className="form-check-label" htmlFor="Tablet" title="Tablet">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM6 1.75H18V0.25H6V1.75ZM19.25 3V21H20.75V3H19.25ZM4.75 21V3H3.25V21H4.75ZM18 22.25H6V23.75H18V22.25ZM11 19.75H13V18.25H11V19.75ZM3.25 21C3.25 22.5188 4.48122 23.75 6 23.75V22.25C5.30964 22.25 4.75 21.6904 4.75 21H3.25ZM19.25 21C19.25 21.6904 18.6904 22.25 18 22.25V23.75C19.5188 23.75 20.75 22.5188 20.75 21H19.25ZM18 1.75C18.6904 1.75 19.25 2.30964 19.25 3H20.75C20.75 1.48122 19.5188 0.25 18 0.25V1.75ZM6 0.25C4.48122 0.25 3.25 1.48122 3.25 3H4.75C4.75 2.30964 5.30964 1.75 6 1.75V0.25Z" fill="#0F2744" />
                                    </svg>
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Mobile" defaultValue="Mobile" />
                                <label className="form-check-label" htmlFor="Mobile" title="Mobile">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM8 1.75H16V0.25H8V1.75ZM17.25 3V21H18.75V3H17.25ZM6.75 21V3H5.25V21H6.75ZM16 22.25H8V23.75H16V22.25ZM11 19.75H13V18.25H11V19.75ZM5.25 21C5.25 22.5188 6.48122 23.75 8 23.75V22.25C7.30964 22.25 6.75 21.6904 6.75 21H5.25ZM17.25 21C17.25 21.6904 16.6904 22.25 16 22.25V23.75C17.5188 23.75 18.75 22.5188 18.75 21H17.25ZM16 1.75C16.6904 1.75 17.25 2.30964 17.25 3H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1.75ZM8 0.25C6.48122 0.25 5.25 1.48122 5.25 3H6.75C6.75 2.30964 7.30964 1.75 8 1.75V0.25Z" fill="#0F2744" />
                                    </svg>
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <button className="full-screen-btn" title="View full screen">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 18V16C14 14.8954 14.8954 14 16 14H18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M9 6L9 8C9 9.10457 8.10457 10 7 10L5 10" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M5 14L7 14C8.10457 14 9 14.8954 9 16L9 18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M18 10L16 10C14.8954 10 14 9.10457 14 8L14 6" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="d-flex align-items-center justify-content-end">
                            <div className="dropdown table-dropdown ques-options">
                                <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    English
                                </button>
                                <div className="dropdown-menu" aria-labelledby="languages">
                                    <a className="dropdown-item" href="#"> French </a>
                                    <a className="dropdown-item" href="#"> Russian </a>
                                    <a className="dropdown-item" href="#"> German </a>
                                </div>
                            </div>
                            <a href="#" className="close-btn ms-3">
                                <svg width={21} height={19} viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.9851 4.06831V3.17676C17.9851 2.46336 17.9807 1.75074 17.9851 1.03734C17.9851 0.601673 18.2137 0.348831 18.5653 0.357388C18.9169 0.365946 19.1195 0.617231 19.1204 1.05756C19.1204 2.53571 19.1109 4.01385 19.1273 5.492C19.1273 5.81408 19.0234 5.9121 18.6631 5.90821C17.0619 5.89265 15.4589 5.90354 13.8603 5.8981C13.6871 5.8981 13.4689 5.90588 13.3632 5.8203C13.2021 5.68727 13.0168 5.46632 13.0359 5.29984C13.0549 5.13335 13.3043 4.89918 13.4792 4.87973C14.0482 4.81594 14.6284 4.83306 15.2052 4.82683C15.7819 4.82061 16.35 4.82683 16.9225 4.82683L16.9978 4.72336C16.7285 4.47363 16.4782 4.20679 16.1881 3.97651C14.3193 2.48981 12.1361 1.77485 9.64198 1.92344C6.13727 2.13194 3.10107 4.20056 1.96141 7.14285C0.82175 10.0851 1.42882 12.7933 3.70294 15.1404C5.12405 16.6061 6.96257 17.4743 9.12585 17.6999C12.0806 18.0111 14.6224 17.1903 16.6722 15.2625C18.1998 13.8256 18.9965 12.0783 19.0606 10.0781C19.0606 10.0392 19.0606 10.0003 19.0606 9.96144C19.084 9.56001 19.3447 9.30094 19.7058 9.31884C20.0444 9.33595 20.273 9.61524 20.2548 9.99645C20.1275 12.7108 18.9662 14.9934 16.6436 16.7446C14.9774 18.0002 13.0367 18.6809 10.8414 18.793C8.26418 18.9244 5.96754 18.2748 3.97487 16.8333C1.98219 15.3917 0.776714 13.5354 0.387879 11.2583C-0.05638 8.65212 0.619105 6.29798 2.43684 4.23402C4.03029 2.42446 6.12082 1.33685 8.66254 0.977431C11.8208 0.530876 14.5791 1.32985 16.9822 3.18609C17.3078 3.4296 17.5919 3.71589 17.9851 4.06831Z" fill="#774936" />
                                </svg>


                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="title-wrap text-center">
                <TopHeading />
            </div>
            <div className="flex-grow-1 page-content-wrap d-flex align-items-center page-preview-wrap">
                <div className="container">


                    {/* Text Question List */}

                    <MultipleQuestions />

                    {/* Yes No Question */}

                    {/* <YesNoQuestion /> */}

                    {/*Opinion Scale Number */}

                    {/* <OpinionScaleNumber/> */}

                    {/*Opinion Scale Star */}

                    {/* <OpinionScaleStar/> */}

                    {/*Opinion Scale Thumbs */}

                    {/* <OpinionScaleThumbs/> */}

                    

                    {/*Slider Question  */}

                    {/* <SliderQuestion/> */}

                    {/*Slider Smilies Question  */}

                    {/* <SliderSmiliesQuestion/> */}

                    {/*Text Question  */}

                    {/* <TextQuestion /> */}



                </div>
            </div>

        </div>
    )
}
